import React from 'react';
import { classNames } from '@vkontakte/vkjs';
import { useVKUIPlatform } from '@dui';
import { getMessageSizes } from './helpers';
import { ImageSize } from './types';
import styles from './MessageListItem.module.css';

const CHILD_MIN_WIDTH_PERCENT = 40;
const CHILD_MAX_WIDTH_PERCENT = 75;

export interface MessagesListItemProps extends React.HTMLAttributes<HTMLDivElement> {
  align?: 'incoming' | 'outgoing';
  children?: React.ReactNode;

  asideButtons?: React.ReactElement[];
  getRootRef?: React.Ref<HTMLDivElement>;
  testId?: string;
  voiceMessageDuration?: number;
  sizes?: ImageSize[];
}

export function MessageListItem(props: MessagesListItemProps) {
  const {
    align = 'left',
    children,
    asideButtons = [],
    getRootRef,
    testId,
    className,
    style,
    voiceMessageDuration,
    sizes,
    ...restProps
  } = props;

  const platform = useVKUIPlatform();
  const { maxWidth, minWidth, widthRatio } = getMessageSizes(sizes, voiceMessageDuration);

  return (
    <div
      data-testid={testId}
      className={classNames(
        styles.root,
        styles[`root__align_${align}`],
        styles[`root__platform_${platform}`],
        className,
      )}
      ref={getRootRef}
      style={
        {
          ...style,
          '--child-min-width': minWidth ? `${minWidth}px` : 'initial',
          '--child-width':
            typeof widthRatio === 'undefined'
              ? 'fit-content'
              : `${CHILD_MIN_WIDTH_PERCENT + (CHILD_MAX_WIDTH_PERCENT - CHILD_MIN_WIDTH_PERCENT) * widthRatio}%`,
          '--child-max-width': maxWidth ? `${maxWidth}px` : `${CHILD_MAX_WIDTH_PERCENT}%`,
        } as React.CSSProperties
      }
      {...restProps}
    >
      {children}
      {asideButtons.length > 0 && (
        <div className={styles.actionsWrapper}>
          {asideButtons.map((asideButton, index) => (
            <span key={`aside-button-${index}`}>{asideButton}</span>
          ))}
        </div>
      )}
    </div>
  );
}
